module.exports = __webpack_public_path__ + "static/media/emos.6bd0d25d.png";